import React, { useState, useCallback, useEffect } from "react";
import Select, { OptionsType } from "react-select";
import SearchTopics from "../../graphql/queries/topic/SearchTopics";
import { debounce } from "lodash";

export type Option = {
  id: string;
  name: string;
  slug: string;
};

export type TopicSelectValue = OptionsType<Option>;

interface VendorMultiSelectProps {
  value?: Option[];
  onChange: (value: OptionsType<Option>) => void;
}

const VendorSelect: React.FC<VendorMultiSelectProps> = (props) => {
  const { value, onChange } = props;
  const [query, setQuery] = useState("");
  const [deferredQuery, setDeferredQuery] = useState("");

  const debouncedSetQuery = useCallback(debounce(setDeferredQuery, 250), []);

  useEffect(() => {
    debouncedSetQuery(query);
  }, [query]);

  const getDefaultValue = () => {
    const vendors = value;

    return vendors?.map((v) => ({
      id: v.id,
      slug: v.slug,
      name: v.name,
    }));
  };

  return (
    <SearchTopics query={deferredQuery} type={"Vendor"}>
      {({ data, loading, fetchMore }) => {
        const options =
          !loading && data?.topics?.length
            ? data.topics.map((topic) => ({
                id: topic.id,
                name: topic.name,
                slug: topic.slug[0],
              }))
            : [];

        return (
          <Select
            className="vendor-multi-select"
            placeholder={"Select Vendors..."}
            defaultValue={getDefaultValue()}
            onChange={onChange}
            isLoading={loading}
            onInputChange={(value) => setQuery(value)}
            closeMenuOnSelec={false}
            isMulti={true}
            options={options as Option[]}
            getOptionValue={(opt) => opt.id}
            getOptionLabel={(opt) => opt.name}
            onMenuScrollToBottom={() =>
              fetchMore({
                variables: { offset: options.length },
                updateQuery: (previousResults, { fetchMoreResult }) => {
                  if (!fetchMoreResult?.topics.length) {
                    return previousResults;
                  }

                  return {
                    topics: [
                      ...previousResults.topics,
                      ...fetchMoreResult.topics,
                    ],
                  };
                },
              })
            }
          />
        );
      }}
    </SearchTopics>
  );
};

export default VendorSelect;
